// AO's CSS scope. The class sits on the element AO mounts into (on <body> standalone), and
// vite.config.js prefixes AO's global stylesheet with it, so keep this module free of Vue imports.
export const STYLE_SCOPE_CLASS = 'assortment-scope';

// Whether AO is running embedded inside the One Retail shell (federated) vs. standalone.
// When embedded, the shell owns the chrome (navbar, footer, AI panel) and AO hides its own.
// Set once by WebshellMain.vue before create-app.js reads it; standalone (main.js) leaves the
// default, so a plain boolean is enough.
let embedded = false;

export function setEmbedded(value) {
  embedded = Boolean(value);
}

export function isEmbedded() {
  return embedded;
}
